<template>
  <v-card class="shadow flex xs12" :class="{ 'mt-3': !accountView }">
    <v-card-text class="pt-1">
      <div
        class="layout row wrap align-center justify-start"
        style="z-index: 5"
      >
        <!-- <v-avatar size="50" v-show="!accountView" tile color="secondary p-32 shadow-md r5 top-out" />
        <div class="mx-3 mb-3 align-start" v-if="!accountView">
          <strong class="body-2">{{$t('balance')}}</strong>
        </div>-->
        <!-- l;l;kkk -->
        <slot name="picker"></slot>
        <v-spacer />
        <v-flex xs12 md4 class="di-flex align-center justify-start mt-1">
          <v-text-field
            outline
            hide-details
            v-model="search"
            class="rounded mx-1"
            :placeholder="$t('search')"
            prepend-inner-icon="search"
          />
          <v-btn
            color="grey darken-2"
            class="mx-0"
            flat
            icon
            @click="printTable(false)"
          >
            <v-icon>print</v-icon>
          </v-btn>
          <v-btn
            color="grey darken-2"
            class="mx-0"
            flat
            icon
            @click="printTable(true)"
          >
            <v-icon>file_download</v-icon>
          </v-btn>
        </v-flex>
      </div>
      <v-data-table
        ref="tbl"
        :search="search"
        :headers="headers"
        :items="transactions"
        :rows-per-page-items="per_page"
      >
        <template slot="items" slot-scope="{ item, index }">
          <td :class="{ 'primary white--text': item.cleared }">
            {{ index + 1 }}
          </td>
          <td>{{ `${item.pretty_type.text}` }}</td>
          <td>
            {{ `${item.pretty_type.lbl}_${item.item.number || item.item.id} ` }}
          </td>
          <!-- <td>{{ item.customer_name }}</td> -->
          <td>{{ item.details }}</td>
          <td>{{ item.date | persianDateFilter(true) }}</td>
          <td>{{ item.date | persianDateFilter }}</td>
          <td>{{ item.time }}</td>
          <!-- <td
            :class="{ 'red--text':item.amount < 0, 'activeColor--text':item.amount > 0}"
          >{{item.amount | currency({symbol:smbl(account.currency_id)})}}</td>-->
          <td
            :class="{
              'red--text': item.debit < 0,
              'activeColor--text': item.debit > 0,
            }"
          >
            <span>
              {{ item.debit | currency({ symbol: smbl(account.currency_id) }) }}
            </span>
          </td>
          <td
            :class="{
              'red--text': item.credit < 0,
              'activeColor--text': item.credit > 0,
            }"
          >
            <span>
              {{
                item.credit | currency({ symbol: smbl(account.currency_id) })
              }}
            </span>
          </td>
          <td
            :class="{
              'red--text': item.balance < 0,
              'activeColor--text': item.balance > 0,
            }"
          >
            {{ item.balance | currency({ symbol: smbl(account.currency_id) }) }}
          </td>
          <!-- <td>
            <v-checkbox
              color="primary"
              icon
              @change="itemCleared(item)"
              hide-details
              single-line
              v-model="item.cleared"
              class="pa-0 ma-0"
            />
          </td> -->
        </template>

        <template slot="footer">
          <tr class="font-weight-bold">
            <td colspan="7" />
            <td>
              {{
                summery.debit | currency({ symbol: smbl(account.currency_id) })
              }}
            </td>
            <td>
              {{
                summery.credit | currency({ symbol: smbl(account.currency_id) })
              }}
            </td>
            <td colspan="2">
              {{
                summery.balance
                  | currency({ symbol: smbl(account.currency_id) })
              }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import curjs from "currency.js";
export default {
  props: {
    initList: {
      default: true,
    },
    accountView: {
      default: false,
    },
    transactions: {
      default: () => [],
    },
    customer: {
      default: () => ({ id: null, accounts: [] }),
    },
    start_date: {
      default: undefined,
    },
    end_date: {
      default: undefined,
    },
    account: {
      default: () => ({
        id: null,
        currency_id: null,
        currency: { rank: "", name: "" },
        type: "cash",
      }),
    },
  },
  data() {
    return {
      items: null,
      dialog: false,
      loading: false,
      showItem: {
        customer: { name: "" },
        form: { items: [], date: "", type: "Credit" },
      },
      search: "",
    };
  },

  computed: {
    summery() {
      let credit = 0;
      let debit = 0;

      this.transactions.forEach((item) => {
        credit += item.credit;
        debit += item.debit;
      });
      return {
        credit,
        debit,
        balance: this.account.balance,
        opening_balance: this.account.opening_balance,
      };
    },
    headers() {
      let items = [
        {
          text: this.$t("number"),
          sortable: false,
          width: "30",
          value: "index",
        },
        {
          text: this.$t("action"),
          value: "pretty_type.text",
          sortable: false,
        },
        {
          width: "80px",
          sortable: false,
          value: "item.id",
          text: this.$t("form_number"),
          computed: (item) =>
            item.pretty_type.lbl + " " + (item.item.number || item.item.id),
        },
        // {
        //   sortable: false,
        //   text: this.$t("account"),
        //   value: "customer_name",
        // },
        {
          text: this.$t("description"),
          sortable: false,
          value: "details",
        },
        {
          value: "date",
          width: "120px",
          sortable: false,
          text: this.$t("persian_date"),
          computed: (item) => this.persianDateFilter(item.date, true),
        },
        {
          value: "date",
          width: "120px",
          sortable: false,
          text: this.$t("date"),
          computed: (item) => this.persianDateFilter(item.date),
        },
        {
          value: "time",
          width: "120px",
          sortable: false,
          text: this.$t("time"),
        },
        // {
        //   text: this.$t("amount"),
        //   sortable: false,
        //   align: "right",
        //   value: "amount"
        // },
        {
          value: "debit",
          sortable: false,
          text: this.$t("debit"),
          computed: (item) => curjs(item.debit).format({symbol:""}),
        },
        {
          value: "credit",
          sortable: false,
          text: this.$t("credit"),
          computed: (item) => curjs(item.credit).format({symbol:""}),
        },
        {
          text: this.$t("balance"),
          sortable: false,
          value: "balance",
          computed: (item) => curjs(item.balance).format({symbol:""}),
        },
        // {
        //   text: this.$t("cleared"),
        //   sortable: false,
        //   width: "20px",
        //   value: "cleared",
        // },
        // { text: this.$t("actions"), sortable: false, align: "center" }
      ];
      return items;
    },
  },
  methods: {
    itemCleared(item) {
      this.axios
        .put(`account-transactions/${item.id}`, item)
        .then((res) => {
          // this.printBill(this.$refs.bill.$el);
          this.loading = false;
          this.$store.commit("showSnackbar", {
            text: this.$t("save_succeed"),
            stateType: "success",
            show: true,
          });
        })
        .catch();
    },
    showCredit(item) {
      this.dialog = true;
    },

    addItems(payload) {
      this.editDialog = false;
      if (this.initList) this.$router.push(`/customers/${payload.customer_id}`);
      else this.$emit("saved", payload);
    },

    printTable(excel) {
      let data = {
        landscape: true,
        headers: this.headers.slice(1),
        items: this.$refs.tbl.filteredItems,
        footers: [
          `<td colspan="3" class="font-weight-bold">${this.$t(
            "opening_balance"
          )}</td>
           <td colspan="100%" class="px-2 font-weight-bold text-xs-left">${curjs(
             this.summery.opening_balance
           )}</td>
          `,
          ` <td colspan="3" class="font-weight-bold">${this.$t(
            "total_debit"
          )}</td>
            <td colspan="100%" class="px-2 font-weight-bold text-xs-left">${curjs(
              this.summery.debit
            )}</td>
          `,
          `<td colspan="3" class="font-weight-bold">${this.$t(
            "total_credit"
          )}</td>
           <td colspan="100%" class="px-2 font-weight-bold text-xs-left">${curjs(
             this.summery.credit
           )}</td>
          `,
          `<td colspan="3" class="font-weight-bold">${this.$t("balance")}</td>
           <td colspan="100%" class="px-2 font-weight-bold text-xs-left">${curjs(
             this.summery.balance
           )}</td>
          `,
        ],
        title: `${this.$t("account_statement_of")} ${this.customer.name} - ${
          this.account.name
        }`,
        sub_title: `( ${this.start_date} - ${this.end_date} )
           to ( ${this.persianDateFilter(this.start_date, true)} - ${this.persianDateFilter(this.end_date, true)} )`,
        // second_sub_title: `از تاریخ  تا تاریخ `,
      };

      if (excel) return this.xl_tables(data, "customers", this.LONG_APP_NAME);
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    },
  },
};
</script>
<style>
.top-out {
  top: -25px;
}
</style>
